import { createAction } from 'redux-actions'

export const muteRemoteVideo = createAction<number>('MUTE_REMOTE_VIDEO')
export const onVideoMuted = createAction<void>('ON_VIDEO_MUTED')
export const muteVideo = createAction<void>('MUTE_VIDEO')
export const onRemoteVideoMuted = createAction<[{ value: string }]>('ON_REMOTE_VIDEO_MUTED')
export const onMuteVideoProgressStateUpdate = createAction<boolean>('ON_MUTE_VIDEO_PROGRESS_STATE_UPDATE')
